<template>
    <div v-show="visible">
        <el-dialog title="审核" :visible.sync="visible"  v-loading="loading"  :close-on-click-modal="false" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
               <el-form-item   prop="checkStatus" label="审核状态">
                    <el-radio-group v-model="form.checkStatus">
                        <el-radio :label="2" >通过</el-radio>
                        <el-radio :label="0">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item prop="checkRemark" label="审核备注">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="form.checkRemark"
                        maxlength="100"
                        show-word-limit>
                    </el-input>
                </el-form-item> 

                <el-form-item  label="人脸验证" v-if="form.checkStatus==2">
                    <el-checkbox v-model="form.checkType"></el-checkbox>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
                <!-- <el-button type="primary" @click="save(2)">确定<span style="color:red;">(跳过验证,不推荐)</span></el-button> -->
            </span>
        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                form:{
                    id:"",
                    checkRemark:"",
                    checkStatus:2,
                    checkType:true
                },
                rules: {
                    checkRemark: [
                        { required: true, message: '审核备注不可以为空', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
             init(data){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id = data;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true;
                        let url= this.checkUserUrl;
                        let data = {
                            id: this.form.id,
                            checkStatus: this.form.checkStatus,
                            checkRemark: this.form.checkRemark,
                            checkType: (this.form.checkType?1:2)
                        };

                        // console.log("审核信息:"+JSON.stringify(data))
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/sys/user/Check.vue